import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--gap);
  background: var(--background-2);
  border-radius: var(--border-radius);
  text-align: center;
  gap: 8px;
`;

export const Text = styled.p`
  margin: 0;
  color: var(--text);
`;

export const ButtonWrapper = styled.div`
  margin-top: 8px;
  margin-bottom: -8px;
`;
